var _path, _path2, _path3, _path4, _circle, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFp01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.48,10.23c-5.43,0-9.85,4.42-9.85,9.85s4.42,9.85,9.85,9.85,9.85-4.42,9.85-9.85-4.42-9.85-9.85-9.85Zm0,18.37c-4.7,0-8.53-3.82-8.53-8.53s3.83-8.53,8.53-8.53,8.53,3.82,8.53,8.53-3.83,8.53-8.53,8.53Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1.32,20.08c0-3.46,1.37-6.7,3.66-8.69.27-.24.3-.66.07-.93-.24-.28-.65-.31-.93-.07C1.54,12.62,0,16.24,0,20.08s1.54,7.46,4.12,9.69c.12.11.28.16.43.16.18,0,.37-.08.5-.23.24-.28.21-.69-.07-.93-2.29-1.98-3.66-5.23-3.66-8.69Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m20.68,10.31c-.28-.23-.7-.19-.93.09-.23.28-.19.7.09.93,2.39,1.97,3.81,5.27,3.81,8.81s-1.38,6.72-3.68,8.7c-.28.24-.31.65-.07.93.13.15.31.23.5.23.15,0,.31-.05.43-.16,2.59-2.23,4.14-5.86,4.14-9.7s-1.6-7.61-4.29-9.83Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m27.27,9.87c-.42,0-.76.32-.76.72v16.55c0,.39.34.72.76.72s.76-.32.76-.72V10.59c0-.39-.34-.72-.76-.72Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.27,
    cy: 29.25,
    r: 0.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m12.07,20.97v4.66h-2.53v-11.12h4.03c.5,0,.95.08,1.37.24.42.16.77.39,1.08.67.3.29.54.63.7,1.03.17.4.25.83.25,1.3s-.08.91-.25,1.31c-.17.39-.4.73-.7,1.02-.3.28-.65.5-1.07.66s-.86.23-1.35.23h-1.54Zm1.39-2.11c.13,0,.26-.03.38-.09.12-.06.22-.14.31-.24.09-.1.16-.22.21-.35.05-.13.08-.28.08-.44s-.03-.3-.08-.43c-.05-.14-.12-.26-.21-.36-.09-.1-.19-.19-.31-.25-.12-.06-.25-.09-.38-.09h-1.39v2.25h1.39Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFp01);
export default __webpack_public_path__ + "static/media/FP01.76023c64b5477aa7dc2d486b98bf8316.svg";
export { ForwardRef as ReactComponent };